import { combineReducers } from 'redux';
import appStore from './appReducer';
import loaderStore from './loader.reducer';

export default combineReducers({
  appStore,
  loaderStore
});
